import Row from "@amzn/meridian/row";
import { FilterSelect } from "./FilterSelect";
import { FILTER_CONFIGS, FilterValues } from "./filterOptions";

export const FILTER_GROUPS = {
    MAIN_FILTERS: FILTER_CONFIGS.slice(0, -1),
    ORDER_FILTER: FILTER_CONFIGS[FILTER_CONFIGS.length - 1],
} as const;

interface FilterGroupProps {
    filters: typeof FILTER_CONFIGS;
    values: FilterValues;
    onChange: (key: string) => (value: string) => void;
    alignment?: "start" | "end";
    disabled?: boolean;
}

export const FilterGroup: React.FC<FilterGroupProps> = ({
    filters,
    values,
    onChange,
    alignment = "start",
    disabled = false,
}) => (
    <Row spacing="300" alignmentHorizontal={alignment} spacingInset={"0 0 0 0"}>
        {filters.map(config => (
            <FilterSelect
                key={config.key}
                label={config.label}
                value={values[config.key]}
                options={config.options}
                onChange={onChange(config.key)}
                disabled={disabled}
            />
        ))}
    </Row>
);
